import { LanguagePicker } from '@doist/marketist'
import { Languages } from '@doist/marketist/dist/components/LanguagePicker/languages'

import { getAllLanguages } from 'i18n/constants'
import { useChangeLanguage } from 'services/useChangeLanguage'

import css from './LanguageHeaderLink.module.css'

export type LanguageHeaderLinkProps = {
    currentLanguage: Languages
}

export function LanguageHeaderLink({ currentLanguage }: LanguageHeaderLinkProps) {
    const { changeLanguage } = useChangeLanguage()

    return (
        <div className={css.languagePicker}>
            <LanguagePicker
                currentLanguage={currentLanguage}
                onLangSelected={changeLanguage}
                languages={getAllLanguages() as Languages[]}
                useShortNames
            />
        </div>
    )
}
